import { useCurrentStateAndParams } from "@uirouter/react";

import { MarketingChannelsDistribution } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistribution";
import { WebsiteHeaderReact } from "app/components/website-header/WebsiteHeaderReact";
import { WWOAllTrafficChannelsOverviewBarChartContainerSI } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/WWOAllTrafficChannelsOverviewBarChartContainerSI";
import TotalVisitsComponentsContainer from "app/pages/website-analysis/TrafficAndEngagement/Components/single/TotalVisitsComponentsContainer";
import { WWOChannelsOverviewBarChartContainerSI } from "app/pages/website-performance/components/ChannelsOverview/WWOChannelsOverviewBarChartContainerSI";
import { EngagementOverviewKpiContainerSI } from "app/pages/website-performance/components/EngagementOverviewKpi/EngagementOverviewKpiContainerSI";
import { WWOSearchTrafficOrganicContainerSI } from "app/pages/website-performance/components/SearchTraffic/organic/WWOSearchTrafficOrganicContainerSI";
import { WWOSearchTrafficPaidContainerSI } from "app/pages/website-performance/components/SearchTraffic/paid/WWOSearchTrafficPaidContainerSI";
import { SectionHeader } from "app/pages/website-performance/components/SectionHeader";
import { WWOSocialOverviewContainerSI } from "app/pages/website-performance/components/SocialOverview/WWOSocialOverviewContainerSI";
import { WWOTopAdDestinationsContainerSI } from "app/pages/website-performance/components/TopAdDestinations/WWOTopAdDestinationsContainerSI";
import { WWOTrafficTopCountriesContainerSI } from "app/pages/website-performance/components/TopCountries/WWOTrafficTopCountriesContainerSI";
import { WWOTopLinkDestinationsContainerSI } from "app/pages/website-performance/components/TopLinkDestinations/WWOTopLinkDestinationsContainerSI";
import { WWOTopPublishersTableContainerSI } from "app/pages/website-performance/components/TopPublishers/WWOTopPublishersTableContainerSI";
import { WWOTopReferringIndustriesContainerSI } from "app/pages/website-performance/components/TopReferringIndustries/WWOTopReferringIndustriesContainerSI";
import { WWOTopReferringWebsitesContainerSI } from "app/pages/website-performance/components/TopReferringWebsites/WWOTopReferringWebsitesContainerSI";
import { WWOTrafficVisitsOverTimeContainerSI } from "app/pages/website-performance/components/TrafficVisitsOverTime/WWOTrafficVisitsOverTimeContainerSI";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    FullWidthWrapper,
    HeaderWithChannelWrapper,
    RowWrapper,
    SectionHeaderWrapper,
    TwoInARowWrapper,
} from "app/pages/website-performance/StyledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { WWOTopAdNetworksContainerSI } from "./TopAdNetworks/WWOTopAdNetworksContainerSI";

export const SIWorldwideOverview = () => {
    const { params } = useCurrentStateAndParams();
    const { webSource, duration } = params;

    return (
        <div className="row-fluid">
            <div className="wwo-widgets">
                <RowWrapper className="row-flex">
                    <FullWidthWrapper
                        className="webkit-overflow"
                        data-automation="website-analysis-header"
                    >
                        <WebsiteHeaderReact />
                    </FullWidthWrapper>

                    <SectionHeaderWrapper>
                        <SectionHeader sectionTitleKey="wa.wwo.section.webaudience.title" />
                    </SectionHeaderWrapper>

                    <FullWidthWrapper data-automation="total-visits-components">
                        <TotalVisitsComponentsContainer />
                    </FullWidthWrapper>

                    <FullWidthWrapper data-automation="engagement-overview-kpi">
                        <EngagementOverviewKpiContainerSI />
                    </FullWidthWrapper>
                </RowWrapper>

                <RowWrapper className="row-flex">
                    <FullWidthWrapper data-automation="traffic-visits-over-time">
                        <WWOTrafficVisitsOverTimeContainerSI />
                    </FullWidthWrapper>
                </RowWrapper>

                {webSource !== devicesTypes.MOBILE ? (
                    <>
                        <RowWrapper className="row-flex pdf-page">
                            <SectionHeaderWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.geo.title" />
                            </SectionHeaderWrapper>
                            <FullWidthWrapper data-automation="traffic-top-countries">
                                <WWOTrafficTopCountriesContainerSI />
                            </FullWidthWrapper>

                            <SectionHeaderWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.marketingmix.title" />
                            </SectionHeaderWrapper>
                            {webSource === devicesTypes.DESKTOP || duration == "28d" ? (
                                <WWOChannelsOverviewBarChartContainerSI />
                            ) : (
                                <WWOAllTrafficChannelsOverviewBarChartContainerSI />
                            )}
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="wwo.search.traffic.organic.section.title" />
                                <MarketingChannelsDistribution marketingChannelsType={4} />
                            </HeaderWithChannelWrapper>

                            <FullWidthWrapper data-automation="search-traffic-organic">
                                <WWOSearchTrafficOrganicContainerSI />
                            </FullWidthWrapper>
                        </RowWrapper>

                        <RowWrapper className="row-flex pdf-page">
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="wwo.search.traffic.paid.section.title" />
                                <MarketingChannelsDistribution marketingChannelsType={5} />
                            </HeaderWithChannelWrapper>

                            <FullWidthWrapper data-automation="search-traffic-paid">
                                <WWOSearchTrafficPaidContainerSI />
                            </FullWidthWrapper>

                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="analysis.sources.referrals.title" />
                                <MarketingChannelsDistribution marketingChannelsType={2} />
                            </HeaderWithChannelWrapper>

                            <TwoInARowWrapper>
                                <FullWidthWrapper data-automation="top-referring-websites">
                                    <WWOTopReferringWebsitesContainerSI />
                                </FullWidthWrapper>
                                <FullWidthWrapper data-automation="top-referring-industries">
                                    <WWOTopReferringIndustriesContainerSI />
                                </FullWidthWrapper>
                            </TwoInARowWrapper>

                            <TwoInARowWrapper>
                                <FlexColumn>
                                    <SectionHeaderWrapper>
                                        <SectionHeader sectionTitleKey="analysis.destination.out.title" />
                                    </SectionHeaderWrapper>
                                    <WWOTopLinkDestinationsContainerSI />
                                </FlexColumn>
                                <FlexColumn>
                                    <SectionHeaderWrapper>
                                        <SectionHeader sectionTitleKey="analysis.destination.paidout.title" />
                                    </SectionHeaderWrapper>
                                    <WWOTopAdDestinationsContainerSI />
                                </FlexColumn>
                            </TwoInARowWrapper>
                        </RowWrapper>

                        <RowWrapper className="row-flex pdf-page">
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="analysis.sources.social.title" />
                                <MarketingChannelsDistribution marketingChannelsType={3} />
                            </HeaderWithChannelWrapper>

                            <FullWidthWrapper>
                                <WWOSocialOverviewContainerSI />
                            </FullWidthWrapper>
                        </RowWrapper>

                        <RowWrapper className="row-flex pdf-page">
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.displayads.title" />
                                <MarketingChannelsDistribution marketingChannelsType={6} />
                            </HeaderWithChannelWrapper>
                            {salesSettingsHelper.isSiAdNetworksFeatureEnabled ? (
                                <TwoInARowWrapper>
                                    <WWOTopAdNetworksContainerSI />
                                    <WWOTopPublishersTableContainerSI />
                                </TwoInARowWrapper>
                            ) : (
                                <FullWidthWrapper>
                                    <WWOTopPublishersTableContainerSI />
                                </FullWidthWrapper>
                            )}
                        </RowWrapper>
                    </>
                ) : null}
            </div>
        </div>
    );
};
